<template>
  <div class="bg-gray-450">
    <router-view />
  </div>

  <notifications
    position="top right"
    classes="vue-notification"
  />

  <ConfirmDialog />
  <transition name="fade">
    <div v-if="loading"
         class="fixed inset-0 bg-black/10 backdrop-blur-md flex items-center justify-center z-[100] p-4"
    >
      <div class="text-center text-blue-450">
        <p><i class="fa fa-spinner text-[52px] animate-spin"></i></p>
        <p class="mt-2 text-[14px]"> Loading...</p>
      </div>

    </div>
  </transition>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog'
import store from "@/vuex/store";

export default {
  name: 'App',
  components: {
    ConfirmDialog
  },
  computed: {
    loading() {
      return store.getters["live/getLoading"]
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/main";
</style>
<!--<template>-->
<!--  <div id="nav">-->
<!--    <router-link to="/">-->
<!--      Home-->
<!--    </router-link> |-->
<!--    <router-link to="/about">-->
<!--      About-->
<!--    </router-link>-->
<!--  </div>-->
<!--  <router-view />-->
<!--</template>-->

<!--<style lang="scss">-->
<!--#app {-->
<!--  font-family: Avenir, Helvetica, Arial, sans-serif;-->
<!--  -webkit-font-smoothing: antialiased;-->
<!--  -moz-osx-font-smoothing: grayscale;-->
<!--  text-align: center;-->
<!--  color: #2c3e50;-->
<!--}-->

<!--#nav {-->
<!--  padding: 30px;-->

<!--  a {-->
<!--    font-weight: bold;-->
<!--    color: #2c3e50;-->

<!--    &.router-link-exact-active {-->
<!--      color: #42b983;-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</style>-->
